var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#565C65","fillRule":"evenodd","d":"M4.457 6.515c.183 0 .332.148.332.33V19.67a.331.331 0 0 1-.332.331H.627a.332.332 0 0 1-.334-.331V6.846c0-.183.15-.331.333-.331zm11.367-.317c2.959 0 5.176 1.928 5.176 6.07v7.4a.33.33 0 0 1-.332.332h-3.832a.331.331 0 0 1-.332-.331v-6.884c0-1.811-.649-3.048-2.278-3.048-1.241 0-1.98.833-2.305 1.639-.119.288-.15.688-.15 1.093v7.2a.332.332 0 0 1-.331.331H7.608a.33.33 0 0 1-.332-.331c.01-1.834.048-10.728.008-12.819a.33.33 0 0 1 .332-.335h3.824c.184 0 .332.148.332.33v1.581c.597-.917 1.663-2.228 4.052-2.228zM2.406 0a2.404 2.404 0 0 1 2.408 2.4c0 1.325-1.078 2.4-2.408 2.4A2.403 2.403 0 0 1 0 2.4C0 1.075 1.078 0 2.406 0z"}));
}

Linkedin.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
